// extracted by mini-css-extract-plugin
module.exports = {"message":"GlobalInfoMessage_message__YCsA8","icon":"GlobalInfoMessage_icon__gi6Mp","close":"GlobalInfoMessage_close__Jv4D4","wrapper":"GlobalInfoMessage_wrapper__PRsKv"};